var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { staticClass: "mt-10" },
    [
      _vm.unified_kiosk_landing === 1 || _vm.unified_kiosk_landing === 3
        ? _c(
            "v-col",
            {
              attrs: {
                cols: "12",
                sm:
                  _vm.unified_kiosk_landing === 1 ||
                  _vm.unified_kiosk_landing === 3
                    ? 6
                    : 0,
                "offset-sm": _vm.unified_kiosk_landing === 1 ? 3 : 0
              }
            },
            [
              _c("v-hover", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var hover = ref.hover
                        return [
                          _c(
                            "v-card",
                            {
                              staticClass: "mx-auto",
                              class: { "on-hover": hover },
                              attrs: {
                                elevation: hover ? 16 : 2,
                                height: "400",
                                "max-width": "350"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.chooseRentDuration("daily")
                                }
                              }
                            },
                            [
                              _c("v-img", {
                                attrs: {
                                  src: "/img/snow2.jpg",
                                  height: "300px"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-card-title", [
                                _c("h3", { staticClass: "mob-h3-font" }, [
                                  _vm._v("Daily Reservation")
                                ])
                              ])
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  585607915
                )
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.unified_kiosk_landing === 2 || _vm.unified_kiosk_landing === 3
        ? _c(
            "v-col",
            {
              attrs: {
                cols: "12",
                sm:
                  _vm.unified_kiosk_landing === 2 ||
                  _vm.unified_kiosk_landing === 3
                    ? 6
                    : 0,
                "offset-sm": _vm.unified_kiosk_landing === 2 ? 3 : 0
              }
            },
            [
              _c("v-hover", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var hover = ref.hover
                        return [
                          _c(
                            "v-card",
                            {
                              staticClass: "mx-auto",
                              class: { "on-hover": hover },
                              attrs: {
                                elevation: hover ? 16 : 2,
                                height: "400",
                                "max-width": "350"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.chooseRentDuration("seasonal")
                                }
                              }
                            },
                            [
                              _c("v-img", {
                                attrs: {
                                  src: "/img/snow1.jpg",
                                  height: "300px"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-card-title", [
                                _c("h3", { staticClass: "mob-h3-font" }, [
                                  _vm._v("Seasonal Reservation")
                                ])
                              ])
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1743617352
                )
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }